export default __webpack_public_path__ + "static/sync-circle-logo-1066e41c01dca7cd972030d2e55afeb8.png";